import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@hs/ui-core-inputs';
import { ModalDirective } from '@hs/ui-core-layout';

import { DashboardNote, SaveDashboardNote } from '../../../models/dashboard-note';
import { EditDashboardNoteComponent } from '../edit-dashboard-note/edit-dashboard-note.component';
import { ViewNoteButtonComponent } from '../view-note-button/view-note-button.component';

@Component({
    selector: 'ddv-edit-dashboard-note',
    templateUrl: './edit-dashboard-note-dropdown.component.html',
    styleUrls: ['./edit-dashboard-note-dropdown.component.scss'],
    imports: [
        ViewNoteButtonComponent,
        ButtonComponent,
        EditDashboardNoteComponent,
        ModalDirective,
    ],
})
export class EditDashboardNoteDropdownComponent {
    @Input() note: DashboardNote | undefined;

    @Output() deleteNote = new EventEmitter<void>();
    @Output() saveNote = new EventEmitter<SaveDashboardNote>();

    protected showModal = false;

    protected onSaveNote(event: SaveDashboardNote): void {
        this.showModal = false;
        this.saveNote.emit(event);
    }

    protected onDeleteNote(): void {
        this.showModal = false;
        this.deleteNote.emit();
    }
}
